module.exports = __webpack_public_path__ + "static/media/login-bg.8dd7891a.jpg";